module.exports = __webpack_public_path__ + "assets/img/2817.0f567622.svg";